(function () {
  const money = (cents) =>
    new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN', maximumFractionDigits: 0 }).format(
      cents / 100
    );

  const tierTotalsFromUnitPrices = (unitPrices) => {
    const p1 = Math.round(Number(unitPrices?.['1'] ?? unitPrices?.[1] ?? 0));
    const p2 = Math.round(Number(unitPrices?.['2'] ?? unitPrices?.[2] ?? 0));
    const p3 = Math.round(Number(unitPrices?.['3'] ?? unitPrices?.[3] ?? 0));
    if (!p1) return [];

    const u2 = p2 || p1;
    const u3 = p3 || p1;
    const total1 = p1;
    const total2 = u2 * 2;
    const total3 = u3 * 3;

    return [
      { qty: 1, unit: p1, total: total1, savings: 0 },
      { qty: 2, unit: u2, total: total2, savings: p1 * 2 - total2 },
      { qty: 3, unit: u3, total: total3, savings: p1 * 3 - total3 },
    ];
  };

  const getConfig = () => {
    const el = document.getElementById('w1gk-pdp-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch {
      return null;
    }
  };

  const findVariant = (config, size) => {
    if (!size) return null;
    return config.variants.find((v) => v.size === size) ?? null;
  };

  const findProductForm = () =>
    document.querySelector('[data-w1gk-pdp-form]') ||
    document.querySelector('.w1gk-pdp-atc form[data-type="add-to-cart-form"]') ||
    document.querySelector('.product-information product-form-component form[data-type="add-to-cart-form"]');

  const getMaxTierQty = (variant) => {
    if (!variant?.available) return 0;
    if (!variant.inventoryTracked) return 3;
    const qty = Math.max(0, Number(variant.inventoryQuantity ?? 0));
    return Math.min(3, qty);
  };

  const pairsLabel = (qty) => {
    if (qty === 1) return '1 para';
    if (qty === 2) return '2 pary';
    if (qty === 3) return '3 pary';
    return `${qty} szt.`;
  };

  const dispatchQuantityUpdate = (quantity) => {
    document.dispatchEvent(
      new CustomEvent('quantity-selector:update', {
        bubbles: true,
        detail: { quantity },
      })
    );
  };

  class W1gkPdpController {
    constructor() {
      this.config = getConfig();
      if (!this.config) return;

      this.form = findProductForm();
      this.variantInput = this.form?.querySelector('[name="id"]');
      this.qtyInput = this.form?.querySelector('[name="quantity"]');
      this.formComponent = this.form?.closest('product-form-component');

      this.selectedSize = this.config.defaultSize;
      this.selectedTier = this.config.defaultTier || 1;
      this.tiers = [];

      document.addEventListener('click', (e) => this.onClick(e));
      document.addEventListener('variant:update', (e) => this.onVariantUpdate(e));

      this.bindSizer();
      this.bindAtcSync();
      this.syncVariant();
      this.syncActiveUi();
    }

    bindAtcSync() {
      if (!this.form) return;

      let atcLocked = false;

      const syncBeforeAdd = () => {
        const variant = findVariant(this.config, this.selectedSize);
        if (variant && this.variantInput) {
          this.variantInput.value = String(variant.id);
        }
        const maxQty = getMaxTierQty(variant);
        let tier =
          this.tiers.find((t) => t.qty === this.selectedTier) ||
          this.tiers[0];
        if (tier && maxQty > 0 && tier.qty > maxQty) {
          tier =
            [...this.tiers].reverse().find((t) => t.qty <= maxQty) ||
            tier;
          this.selectedTier = tier.qty;
        }
        if (tier) {
          this.syncTierProperties(tier);
          if (this.qtyInput) this.qtyInput.value = String(tier.qty);
          if (this.formComponent) {
            this.formComponent.dataset.quantityDefault = String(tier.qty);
          }
        }
      };

      const guardAdd = (e) => {
        syncBeforeAdd();
        if (atcLocked) {
          e.preventDefault();
          e.stopImmediatePropagation();
          return;
        }
        atcLocked = true;
        window.setTimeout(() => {
          atcLocked = false;
        }, 1500);
      };

      this.form.addEventListener('submit', guardAdd, true);
    }

    getAddToCartComponents() {
      return this.form ? Array.from(this.form.querySelectorAll('add-to-cart-component')) : [];
    }

    setAddToCartEnabled(available) {
      const submit = this.form?.querySelector('button[type="submit"]');
      if (submit) submit.disabled = !available;

      this.getAddToCartComponents().forEach((component) => {
        if (available && typeof component.enable === 'function') {
          component.enable();
        } else if (!available && typeof component.disable === 'function') {
          component.disable();
        }
      });
    }

    syncStickyBar(variant) {
      const sticky = document.querySelector(
        `sticky-add-to-cart[data-product-id="${this.config.productId}"]`
      );
      if (!sticky) return;

      const available = Boolean(variant?.available);
      sticky.dataset.variantAvailable = available ? 'true' : 'false';
      if (variant?.id) sticky.dataset.currentVariantId = String(variant.id);

      const variantTitle = sticky.querySelector('.sticky-add-to-cart__variant');
      if (variantTitle && this.selectedSize) {
        variantTitle.textContent = this.selectedSize;
        variantTitle.style.display = '';
      }

      const stickyBtn = sticky.querySelector('[ref="addToCartButton"]');
      if (stickyBtn) stickyBtn.disabled = !available;
    }

    syncStickyQuantity(qty) {
      dispatchQuantityUpdate(qty);
      const sticky = document.querySelector(
        `sticky-add-to-cart[data-product-id="${this.config.productId}"]`
      );
      if (sticky) sticky.dataset.initialQuantity = String(qty);
    }

    onVariantUpdate(e) {
      const variantId = e.detail?.resource?.id;
      if (!variantId) return;

      const match = this.config.variants.find((v) => String(v.id) === String(variantId));
      if (!match) return;

      this.selectedSize = match.size;
      this.syncVariant();
      this.syncActiveUi();
    }

    computeTiers(variant) {
      const base = Math.round(variant?.price ?? 0);

      if (!this.config.tierEnabled) {
        if (!base) return [];
        return [{ qty: 1, unit: base, total: base, savings: 0 }];
      }

      const unitPrices = this.config.tierUnitPrices;
      if (unitPrices && (unitPrices['1'] || unitPrices[1])) {
        return tierTotalsFromUnitPrices(unitPrices);
      }

      if (!base) return [];
      return [
        { qty: 1, unit: base, total: base, savings: 0 },
        { qty: 2, unit: base, total: base * 2, savings: 0 },
        { qty: 3, unit: base, total: base * 3, savings: 0 },
      ];
    }

    refreshPricing(variant) {
      this.tiers = this.computeTiers(variant);
      this.syncTierVisibility(variant);
      this.fillTierCards();
      this.syncTier();
    }

    syncTierVisibility(variant) {
      const maxQty = getMaxTierQty(variant);

      document.querySelectorAll('[data-w1gk-tier]').forEach((card) => {
        const tierQty = Number(card.dataset.w1gkTier);
        const allowed = maxQty > 0 && tierQty <= maxQty;
        card.hidden = !allowed;
        card.disabled = !allowed;
        card.setAttribute('aria-hidden', allowed ? 'false' : 'true');
      });

      const grid = document.querySelector('[data-w1gk-tier-grid]');
      if (grid) {
        grid.style.setProperty('--w1gk-tier-count', String(Math.max(1, maxQty)));
      }

      if (maxQty > 0 && this.selectedTier > maxQty) {
        this.selectedTier = maxQty;
      }
    }

    fillTierCards() {
      if (!this.tiers.length) return;

      this.tiers.forEach((t) => {
        const total = document.querySelector(`[data-w1gk-tier-total="${t.qty}"]`);
        if (total) total.textContent = money(t.total);

        const unit = document.querySelector(`[data-w1gk-tier-unit="${t.qty}"]`);
        if (unit) unit.textContent = `${money(t.unit)} za parę`;

        const save = document.querySelector(`[data-w1gk-tier-save="${t.qty}"]`);
        if (save) {
          if (t.savings > 0) {
            save.textContent = `Oszczędzasz ${money(t.savings)}`;
            save.hidden = false;
          } else {
            save.textContent = '';
            save.hidden = true;
          }
        }
      });
    }

    onClick(e) {
      const sizeBtn = e.target.closest('[data-w1gk-size]');
      if (sizeBtn && !sizeBtn.disabled) {
        this.selectedSize = sizeBtn.dataset.w1gkSize;
        this.syncVariant();
        this.syncActiveUi();
        return;
      }

      const tierCard = e.target.closest('[data-w1gk-tier]');
      if (tierCard && !tierCard.hidden && !tierCard.disabled) {
        this.selectedTier = Number(tierCard.dataset.w1gkTier);
        this.syncTier();
        this.syncActiveUi();
      }
    }

    bindSizer() {
      /* assets/w1gk-glove-finder.js */
    }

    syncActiveUi() {
      document.querySelectorAll('[data-w1gk-size]').forEach((btn) => {
        btn.classList.toggle('is-active', btn.dataset.w1gkSize === this.selectedSize);
      });
      document.querySelectorAll('[data-w1gk-size-label]').forEach((el) => {
        el.textContent = this.selectedSize;
      });
      document.querySelectorAll('[data-w1gk-tier]').forEach((card) => {
        card.classList.toggle('is-active', Number(card.dataset.w1gkTier) === this.selectedTier);
      });
    }

    syncVariant() {
      const variant = findVariant(this.config, this.selectedSize);
      if (!this.variantInput) return;

      if (!variant) {
        this.setAddToCartEnabled(false);
        return;
      }

      this.variantInput.value = String(variant.id);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', url);

      this.setProperty('Rozmiar', this.selectedSize || '');
      this.setAddToCartEnabled(variant.available);
      this.syncStickyBar(variant);

      this.refreshPricing(variant);
    }

    syncTier() {
      const variant = findVariant(this.config, this.selectedSize);
      const maxQty = getMaxTierQty(variant);
      if (maxQty > 0 && this.selectedTier > maxQty) {
        this.selectedTier = maxQty;
        this.syncActiveUi();
      }

      const tier =
        this.tiers.find((t) => t.qty === this.selectedTier && t.qty <= maxQty) ||
        [...this.tiers].reverse().find((t) => t.qty <= maxQty) ||
        this.tiers[0];
      if (!tier || (maxQty > 0 && tier.qty > maxQty)) return;

      if (this.qtyInput) this.qtyInput.value = String(tier.qty);
      if (this.formComponent) this.formComponent.dataset.quantityDefault = String(tier.qty);

      this.syncTierProperties(tier);
      this.syncStickyQuantity(tier.qty);

      const label = `Dodaj do koszyka · ${pairsLabel(tier.qty)} · ${money(tier.total)}`;

      document.querySelectorAll('[data-w1gk-cta-label]').forEach((el) => {
        el.textContent = label;
      });
      document.querySelectorAll('[data-w1gk-cta] .add-to-cart-text__content span span').forEach((el) => {
        el.textContent = label;
      });

      document.dispatchEvent(
        new CustomEvent('w1gk:pdp-tier-change', {
          detail: { savings: tier.savings, qty: tier.qty },
        })
      );
    }

    syncTierProperties(tier) {
      this.setProperty('_w1gk_tier_qty', String(tier.qty));
      this.setProperty('_w1gk_tier_unit_cents', String(tier.unit));
      this.setProperty('Rozmiar', this.selectedSize || '');
    }

    setProperty(name, value) {
      let input = this.form?.querySelector(`[name="properties[${name}]"]`);
      if (!input && this.form) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[${name}]`;
        this.form.appendChild(input);
      }
      if (input) input.value = value;
    }
  }

  const updateSavingsDisplay = (savings) => {
    const value = savings > 0 ? money(savings) : '—';
    document.querySelectorAll('[data-w1gk-savings-amount]').forEach((amount) => {
      amount.textContent = value;
    });
    document.querySelectorAll('[data-w1gk-savings-column]').forEach((column) => {
      column.hidden = savings <= 0;
    });
  };

  const initSavings = () => {
    document.addEventListener('w1gk:pdp-tier-change', (e) => {
      updateSavingsDisplay(e.detail?.savings ?? 0);
    });
  };

  const initFaq = () => {
    document.querySelectorAll('[data-w1gk-faq-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const item = btn.closest('[data-w1gk-faq-item]');
        const answer = item?.querySelector('[data-w1gk-faq-answer]');
        const willOpen = answer?.hidden;
        document.querySelectorAll('[data-w1gk-faq-answer]').forEach((a) => (a.hidden = true));
        document.querySelectorAll('[data-w1gk-faq-toggle]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
        if (answer && willOpen) {
          answer.hidden = false;
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  };

  const boot = () => {
    if (window.__w1gkPdpBooted) return;
    window.__w1gkPdpBooted = true;
    initSavings();
    new W1gkPdpController();
    initFaq();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
